import { Navigate } from "react-router-dom";
import { ForgePageLoader } from "@/components/ForgeLoader";
import { useFinanceSettingsLanding } from "./useSettingsNav";

/**
 * `/finance/settings`, the target of every Finance settings page's "Settings" crumb, the Finance menu
 * and the Finance dashboard tile. It used to be a fixed redirect to Accounting setup, which sends a
 * viewer whose organization has accounting switched off Home and one whose plan lacks it to a bare
 * upgrade card, so a contributions-only organization clicking "Settings" left Finance settings
 * altogether (#7786). It now goes to the first page the viewer can use (see financeSettingsLandingHref).
 *
 * It waits for the access state to load: redirecting early would send an organization with full
 * accounting to the wrong page.
 */
export function FinanceSettingsIndex() {
  const { loading, href } = useFinanceSettingsLanding();
  if (loading) return <ForgePageLoader />;
  // No page at all cannot happen behind ModuleRouteGate("contributions"); keep today's target if it ever does.
  return <Navigate to={href ?? "/finance/settings/accounting-setup"} replace />;
}
